import React from "react";
import OrderDTO from "@/dto/order/OrderDTO";
import { getRealOrderOriginalId } from "@/utils/OrderUtils";
import WithPopoverTip, { getRealBuyerNickName } from "../WithPopoverTip";
import { observer } from "mobx-react-lite";
import GlobalStore from "@/store";
import { useGlobalStore } from "@/store/hooks";

interface PddBuyerUsernameProps {
    order: OrderDTO;

    onSearch?: () => void;
}

export function buildPddWebChatUrl(orderOriginalId: string) {
    return `https://mms.pinduoduo.com/chat-merchant/index.html?orderSn=${orderOriginalId}#/`;
}

export function buildPddChatUrl(orderOriginalId: string, shopId: number, globalStore: typeof GlobalStore) {
    try {
        const shop = globalStore.shopMapping.get(shopId);

        return `pddim:sendmsg/?OpeId=open_order&mallcsid=cs_${shop.sellerUsername}&ordersn=${orderOriginalId}`;
    } catch (e) {
        console.error(e);
    }

    return buildPddWebChatUrl(orderOriginalId);
}

const PddBuyerUsername: React.FC<PddBuyerUsernameProps> = observer(function (props) {
    const { order, onSearch } = props;

    const globalStore = useGlobalStore();

    const orderOriginalId = getRealOrderOriginalId(order);

    const imUrl = buildPddChatUrl(orderOriginalId, order.shopId, globalStore);

    return (
        <span>
            <WithPopoverTip onSearch={onSearch}>{getRealBuyerNickName(order)}</WithPopoverTip>

            <a href={imUrl} title="联系买家" target="_blank">
                <img
                    src="//img.alicdn.com/imgextra/i4/54458674/O1CN01CuK1xF2DwkDXT4SQq_!!54458674.png"
                    alt=""
                    style={{ width: 16, height: 16 }}
                />
            </a>
        </span>
    );
});

export default PddBuyerUsername;
